/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-unused-vars */
// @ts-nocheck
import React, { useCallback, useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  TextField,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useFormik } from 'formik';
import { cloneDeep } from 'lodash';
import PropTypes from 'prop-types';
import { string, object, boolean } from 'yup';

import useCommon from '../../Hooks/useCommon';
import useAuth from '../../Hooks/Auth/useAuth';
import useProject from '../../Hooks/Project/useProject';
import { REGULATIONS } from '../../const/CommonConst';
import MODULE_SUB_MODULE_OPERATIONS_TREE from '../../const/ModuleSubModuleOperationsTree';
import utils from '../../utils/utils';
import { SwalToast } from '../Common';
import { DropDown, DropdownItem } from '../Common/DropDown';
import ControlledMultiSelect from '../Common/ControlledMultiSelect';
import DialogTransition from '../Common/Transitions/DialogTransition';
import UserPermission from './UserPermission';
import useTabChange from '../Common/styled/Tabs';

const validationSchema = object({
  name: string()
    .max(255, 'Maximum 255 characters are allowed.')
    .required('Required'),
  description: string()
    .max(250, 'Maximum 250 characters are allowed.')
    .required('Required'),
  type: string().required('Required'),
  is_collaborative: boolean().required('Required'),
});

const moduleNames = [
  'ProjectOverview',
  'Pipeline',
  'UDF',
  'AutomatedDoc',
  'ModelManager',
];
const UNAUTHORIZED_MESSAGE = 'You are not authorized to access this!';

const modulesSubModuleList = {};
Object.values(MODULE_SUB_MODULE_OPERATIONS_TREE).forEach((item) => {
  const access = {};
  if (item?.objKey !== 'ST') {
    Object.values(item.subModules).forEach((subModule) => {
      if (
        subModule?.key !== 'UDF' &&
        subModule?.key !== 'Models' &&
        subModule?.key !== 'TestCaseManager'
      ) {
        access[item?.key] = 'None';
        if (moduleNames.includes(item?.key)) {
          access[`${item?.key}_${subModule?.key}`] = 'No';
        } else {
          access[`${item?.key}_${subModule?.key}`] = 'None';
        }
      }
    });
    modulesSubModuleList[item?.objKey] = {
      ...(item?.key === 'UDF' || item?.key === 'ModelManager'
        ? {
            ...item,
            subModules: Object.fromEntries(
              Object.entries(item.subModules).filter(([key]) => {
                return key !== 'UDF' && key !== 'MM' && key !== 'TCM';
              })
            ),
          }
        : { ...item }),
      permissions: cloneDeep(access),
    };
  }
});

const disabledPermissions = [
  'ProjectOverview_DeleteProject',
  'UDF_DeleteUDF',
  'AutomatedDoc_DeleteDoc',
  'ModelManager_DeleteModel',
  'Pipeline_DeletePipeline',
  'Pipeline_DeleExecutionHistory',
  'Pipeline_DeleteNode',
  'UDF_DeleteJobs',
  'UDF_FileDelete',
  'AutomatedDoc_DeleteTemplate',
  'TaskManager_DeleteDocument',
  'ModelManager_DeleteTestCase',
  'ProjectOverview_ShareProject',
  'ProjectOverview_CloneProject',
  'Pipeline_SharePipeline',
  'Pipeline_ClonePipeline',
  'UDF_ShareUDF',
  'UDF_CloneUDF',
  'AutomatedDoc_CloneDocument',
  'ModelManager_CloneModel',
];

/**
  @function CreateEditProjectModal
 // eslint-disable-next-line max-len
 * @description CreateNewProjectModal- child component of ProjectItemList.Creating new project modal of a user.
 * @param  {function} createNewProject -creating new project
 * @param  {function} updateProject -updating project
 * @param  {function} fetchProjects - fetching user projects
 * @param {boolean} open -open variable
 * @param {function} handleClose - changing state of open variable from null to false
 * @param {object} project -project object
 * @param {function} activateProject -activating project
 * @param {object} permissions -permissions object
 * @param {function} fetchUserProjectsStatus -fetching user projects status
 * @returns {JSX} CreateNewProjectModal UI
 * @example <CreateNewProjectModal createNewProject={createNewProject}
 * fetchProjects={fetchProjects} open={open}/>
 */
function CreateEditProjectModal({
  createNewProject = () => {},
  updateProject = () => {},
  fetchProjects = () => {},
  open = false,
  handleClose = () => {},
  project,
  permissions,
  fetchUserProjectsStatus = () => {},
  fetchProjectTypes = () => {},
  pageIndex,
  pageSize,
  searchTerm,
  projectType,
  modelType,
  sortField,
  sortOrder,
  setProjectList = () => {},
  fromAppHeader,
  editProjectClicked,
  setEditProjectClicked,
  createCollaborativeProjectPermission,
  taskUpdate,
  taskId,
  fetchTasksWithPagination,
  fromTaskManager,
  selectedTaskModelId,
}) {
  const { user, fetchUserAllPermissions } = useAuth();
  const { setIsProjectCreatedFromAppBar, dispatch } = useCommon();
  const [moduleSubModules, setModuleSubModules] = useState({
    '0': cloneDeep(modulesSubModuleList),
  });
  const [moduleSubModulesForGroups, setModuleSubModulesForGroups] = useState({
    '0': cloneDeep(modulesSubModuleList),
  });
  const [userAllPermissions, setUserAllPermissions] = useState({});
  const [ownerModulesSubmodulesList, setOwnerModulesSubmodulesList] = useState(
    {}
  );
  const {
    fetchUserRecipients,
    fetchProjectLevelPermission,
    fetchGroups,
    fetchCollaboratorsPermission,
  } = useProject();
  const [users, setUsers] = React.useState([]);
  const [groups, setGroups] = React.useState([]);
  const [mode, setMode] = React.useState('CREATE');
  const [isCollaborative, setIsCollaborative] = React.useState('False');
  const [projectTypes, setProjectTypes] = React.useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedGroupTab, setSelectedGroupTab] = useState(0);
  const [tabIndex, setTabIndex] = useTabChange(0);

  const UserTab = styled(Tab)(() => ({
    minHeight: '25px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px !important',
    color: (theme) => `${theme.palette.secondary.main}`,
    '&.Mui-selected': {
      backgroundColor: '#BED7FC',
      borderRadius: '3px',
      color: (theme) => `${theme.palette.secondary.main} !important`,
    },
  }));
  const EllipsisBox = styled(Box)({
    width: '120px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  });
  useEffect(() => {
    if (open) {
      fetchUserAllPermissions().then((res) => {
        setUserAllPermissions(res);
      });
    }
  }, [setUserAllPermissions, open]);

  const handleRefreshPeojectList = useCallback(() => {
    fetchProjects(
      pageIndex,
      pageSize,
      searchTerm,
      projectType,
      modelType,
      sortField,
      sortOrder
    ).then((res) => {
      if (fromAppHeader) {
        dispatch(setIsProjectCreatedFromAppBar(true));
      }
      setProjectList(res);
    });
  }, [
    pageIndex,
    pageSize,
    searchTerm,
    projectType,
    modelType,
    sortField,
    sortOrder,
    setProjectList,
  ]);
  const formikForm = useFormik({
    initialValues: {
      name: '',
      description: '',
      type: '',
      regulation: '',
      portfolio: 'Retail/Closed end',
      collaborators: [],
      groups: [],
      is_collaborative: isCollaborative,
      totalUsersSelected: 0,
      totalGroupsSelected: 0,
      created_by: user.userData.username,
    },
    validationSchema,
    onSubmit: (values) => {
      if (
        values?.is_collaborative === true ||
        values?.is_collaborative === 'True'
      ) {
        const usersPermissionData = {};
        const groupPermissionData = {};
        if (values?.collaborators?.length > 0) {
          Object.values(moduleSubModules).forEach((module, key) => {
            let permissionJson = {};
            Object.values(module).forEach((value) => {
              permissionJson = {
                ...permissionJson,
                ...value.permissions,
              };
            });
            permissionJson.ProjectOverview_CreateProject = 'Yes';
            permissionJson.ProjectOverview_IsCollaborative = 'Yes';

            usersPermissionData[values?.collaborators[key]?.id] =
              permissionJson;
          });
        }
        if (values?.groups?.length > 0) {
          Object.values(moduleSubModulesForGroups).forEach((module, key) => {
            let permissionJson = {};
            Object.values(module).forEach((value) => {
              permissionJson = {
                ...permissionJson,
                ...value.permissions,
              };
            });
            permissionJson.ProjectOverview_CreateProject = 'Yes';
            permissionJson.ProjectOverview_IsCollaborative = 'Yes';

            groupPermissionData[values?.groups[key]?.id] = permissionJson;
          });
        }

        // eslint-disable-next-line no-param-reassign
        values.permission_data = {};
        // eslint-disable-next-line no-param-reassign
        values.permission_data.users = usersPermissionData;
        // eslint-disable-next-line no-param-reassign
        values.permission_data.groups = groupPermissionData;

        let collaborativeUsers = [];
        let collaborativeGroups = [];
        values?.collaborators.forEach((u) => {
          collaborativeUsers = [...collaborativeUsers, u?.id];
        });
        // eslint-disable-next-line no-param-reassign
        values.collaborators = collaborativeUsers;
        values?.groups.forEach((u) => {
          collaborativeGroups = [...collaborativeGroups, u?.id];
        });
        // eslint-disable-next-line no-param-reassign
        values.groups = collaborativeGroups;
      }

      if (mode === 'CREATE') {
        const updateValues = {
          ...values,
          ...(!values.regulation ? { regulation: 'Classification' } : {}),
          ...(fromTaskManager
            ? {
                model_id: selectedTaskModelId,
                ...(project?.activeProject?.is_collaborative && {
                  project_id: project?.activeProject?.project_id,
                }),
              }
            : {}),
        };

        if (
          updateValues?.is_collaborative !== true &&
          updateValues?.is_collaborative !== 'True'
        ) {
          createNewProject(updateValues, (resp) => {
            handleClose();
            fetchUserProjectsStatus();
            SwalToast({
              icon: 'success',
              title: resp?.data?.msg
                ? resp?.data?.msg
                : 'Project created successfully.',
            });
            if (fromTaskManager) {
              taskUpdate({
                task_id: taskId,
                project_id: resp?.data?.project_id,
                update_project_id: true,
              }).then(() => {
                fetchTasksWithPagination();
              });
            }
            formikForm.resetForm();
          }).then(() => {
            handleRefreshPeojectList();
          });
        } else if (
          values?.collaborators?.length > 0 ||
          values?.groups?.length > 0
        ) {
          createNewProject(updateValues, (resp) => {
            if (!fromTaskManager) {
              handleClose();
              fetchProjects(
                pageIndex,
                pageSize,
                searchTerm,
                projectType,
                modelType,
                sortField,
                sortOrder
              ).then((res) => {
                if (fromAppHeader) {
                  dispatch(setIsProjectCreatedFromAppBar(true));
                }
                setProjectList(res);
              });
              fetchUserProjectsStatus();
            } else {
              taskUpdate({
                task_id: taskId,
                project_id: resp?.data?.project_id,
                update_project_id: true,
              }).then(() => {
                fetchProjects();
                fetchTasksWithPagination();
              });
            }
            SwalToast({
              icon: 'success',
              title: resp?.data?.msg
                ? resp?.data?.msg
                : 'Project created successfully.',
            });
            formikForm.resetForm();
            handleClose();
          });
        } else {
          SwalToast({
            icon: 'error',
            title: 'At least one user or one group is required.',
          });
        }
      } else {
        const updateValues = {
          ...values,
          id: project?.project_id,
        };
        delete updateValues.user_id;
        if (
          updateValues?.is_collaborative !== true &&
          updateValues?.is_collaborative !== 'True'
        ) {
          updateProject(updateValues).then(
            (resp) => {
              handleClose();
              // fetchUserProjects(
              //   [
              //     'project_id',
              //     'clone_status',
              //     'share_status',
              //     'name',
              //     'is_archived',
              //     'regulation',
              //     'user_id',
              //   ].join()
              // ).then();
              setEditProjectClicked(false);
              fetchProjects(
                pageIndex,
                pageSize,
                searchTerm,
                projectType,
                modelType,
                sortField,
                sortOrder,
                resp?.data
              ).then((res) => {
                setProjectList(res);
              });
              SwalToast({
                icon: 'success',
                title: `Project ${
                  resp?.data?.name ? resp?.data?.name?.trim() : ''
                } updated successfully.`,
              });
              formikForm.resetForm();
            },
            () => {}
          );
        } else if (
          values?.collaborators?.length > 0 ||
          values?.groups?.length > 0
        ) {
          updateProject(updateValues).then(
            (resp) => {
              // fetchUserProjects(
              //   [
              //     'project_id',
              //     'clone_status',
              //     'share_status',
              //     'name',
              //     'is_archived',
              //     'regulation',
              //     'user_id',
              //   ].join()
              // ).then();

              handleClose();
              fetchProjects(
                pageIndex,
                pageSize,
                searchTerm,
                projectType,
                modelType,
                sortField,
                sortOrder,
                resp?.data
              ).then((res) => {
                setProjectList(res);
              });
              SwalToast({
                icon: 'success',
                title: `Project ${
                  resp?.data?.name ? resp?.data?.name?.trim() : ''
                } updated successfully.`,
              });
              formikForm.resetForm();
            },
            () => {}
          );
        } else {
          SwalToast({
            icon: 'error',
            title: 'At least one user or one group is required.',
          });
        }
      }
    },
  });

  const hasCollaborators = formikForm?.values?.collaborators?.length !== 0;
  const hasGroups = formikForm?.values?.groups?.length !== 0;
  const displayCollaboratorsOrGroups =
    isCollaborative === 'True' && (hasCollaborators || hasGroups);

  useEffect(() => {
    if (userAllPermissions && Object.keys(userAllPermissions)?.length > 0) {
      const copyOfModuleSubModules = cloneDeep(modulesSubModuleList);
      Object.entries(userAllPermissions)?.forEach(([key, value]) => {
        Object.values(copyOfModuleSubModules).forEach((item) => {
          if (key.split('_')[0] === item.key) {
            copyOfModuleSubModules[item.objKey].permissions[key] =
              value || 'None';
          }
        });
      });
      Object.entries(copyOfModuleSubModules).forEach(([key, value]) => {
        const submodulePermissions = Object.values(value?.permissions)?.slice(
          1
        );
        const permissionMap = new Map();
        submodulePermissions.forEach((item) => {
          permissionMap.set(item, permissionMap.get(item) + 1 || 1);
        });
        const iterator = permissionMap.keys();
        if (iterator.next().value === 'No' || iterator.next().value === 'Yes') {
          const noCount = permissionMap.get('No') || 0;
          const yesCount = permissionMap.get('Yes') || 0;
          if (noCount === 0) {
            copyOfModuleSubModules[key].permissions[value.key] = 'Manage';
          } else if (yesCount === 0) {
            copyOfModuleSubModules[key].permissions[value.key] = 'None';
          } else {
            copyOfModuleSubModules[key].permissions[value.key] = 'Custom';
          }
        } else {
          const noneCount = permissionMap.get('None') || 0;
          const manageCount = permissionMap.get('Manage') || 0;
          const viewCount = permissionMap.get('View') || 0;
          if (noneCount !== 0 && manageCount === 0 && viewCount === 0) {
            copyOfModuleSubModules[key].permissions[value.key] = 'None';
          } else if (noneCount === 0 && manageCount !== 0 && viewCount === 0) {
            copyOfModuleSubModules[key].permissions[value.key] = 'Manage';
          } else if (noneCount === 0 && manageCount === 0 && viewCount !== 0) {
            copyOfModuleSubModules[key].permissions[value.key] = 'View';
          } else {
            copyOfModuleSubModules[key].permissions[value.key] = 'Custom';
          }
        }
      });
      setOwnerModulesSubmodulesList({ ...cloneDeep(copyOfModuleSubModules) });
    }
  }, [setOwnerModulesSubmodulesList, mode, userAllPermissions]);
  useEffect(() => {
    if (project && editProjectClicked) {
      setMode('EDIT');
      if (
        project?.is_collaborative &&
        (groups?.length > 0 || users?.length > 0)
      ) {
        fetchProjectLevelPermission(project?.project_id).then((resp) => {
          const projectPermission = cloneDeep(resp?.data?.user_ids);
          const moduleSubmodulePermission = Object.values(projectPermission);
          const collabUsersId = Object.keys(projectPermission);
          const collabUsers = [];
          collabUsersId.forEach((collab) => {
            const foundUser = users?.filter(
              (u) => u?.id?.toString() === collab
            );
            if (foundUser?.length) {
              collabUsers.push(foundUser[0]);
            }
          });
          const userPermission = {};
          moduleSubmodulePermission.forEach((module, idx) => {
            const copyOfModuleSubModules = cloneDeep(modulesSubModuleList);
            Object.entries(module)?.forEach(([key, value]) => {
              Object.values(copyOfModuleSubModules).forEach((item) => {
                if (key.split('_')[0] === item.key) {
                  copyOfModuleSubModules[item.objKey].permissions[key] =
                    value || 'None';
                }
              });
            });
            userPermission[idx] = cloneDeep(copyOfModuleSubModules);
          });

          const groupPermissions = cloneDeep(resp?.data?.group_ids);
          const moduleSubmoduleGroupPermission =
            Object.values(groupPermissions);
          const groupIds = Object.keys(groupPermissions);
          const collabGroups = [];
          groupIds.forEach((collab) => {
            const foundUser = groups?.filter((u) => u?.id === collab);
            if (foundUser?.length) {
              collabGroups.push(foundUser[0]);
            }
          });
          const groupPermissionData = {};
          moduleSubmoduleGroupPermission.forEach((module, idx) => {
            const copyOfModuleSubModules = cloneDeep(modulesSubModuleList);
            Object.entries(module)?.forEach(([key, value]) => {
              Object.values(copyOfModuleSubModules).forEach((item) => {
                if (key.split('_')[0] === item.key) {
                  copyOfModuleSubModules[item.objKey].permissions[key] =
                    value || 'None';
                }
              });
            });
            groupPermissionData[idx] = cloneDeep(copyOfModuleSubModules);
          });
          setIsCollaborative(project?.is_collaborative ? 'True' : 'False');
          setModuleSubModules(cloneDeep(userPermission));
          setModuleSubModulesForGroups(cloneDeep(groupPermissionData));
          formikForm.setFieldValue('name', project?.name);
          formikForm.setFieldValue('description', project?.description);
          formikForm.setFieldValue('type', project?.type);
          formikForm.setFieldValue('regulation', project?.regulation);
          formikForm.setFieldValue('portfolio', project?.portfolio);
          formikForm.setFieldValue('collaborators', collabUsers);
          formikForm.setFieldValue('is_collaborative', true);
          formikForm.setFieldValue('totalUsersSelected', collabUsersId?.length);
          formikForm.setFieldValue('groups', collabGroups);
        });
      }
      formikForm.setValues({ ...project });
      const timerId = setTimeout(() => {
        formikForm.validateForm();
      }, 1000);
      return () => clearTimeout(timerId);
    }
  }, [project, editProjectClicked, groups, users]);
  useEffect(() => {
    if (open) {
      if (
        (isCollaborative === 'True' || project?.is_collaborative) &&
        editProjectClicked
      ) {
        fetchUserRecipients(null, null, null, (res) => {
          if (res?.data?.length) {
            const userList = res?.data?.filter(
              (ele) => ele?.id !== user?.userData?.id
            );
            setUsers(userList);
          }
        });
        fetchGroups().then((res) => {
          setGroups(res?.data);
        });
      }
      if (projectTypes?.length <= 0) {
        fetchProjectTypes().then((res) => {
          setProjectTypes(res);
        });
      }
    }
  }, [open, isCollaborative]);
  const handleRadioChange = useCallback(
    (event) => {
      setIsCollaborative(event.target.value);
      formikForm.setFieldValue('is_collaborative', event.target.value);
      formikForm.setFieldValue('collaborators', []);
      formikForm.setFieldValue('groups', []);
    },
    [setIsCollaborative, formikForm]
  );
  const handleTabChange = useCallback(
    (_event, newValue) => {
      setSelectedTab(newValue);
    },
    [setSelectedTab]
  );
  const handleTabChangeForGroups = useCallback(
    (_event, newValue) => {
      setSelectedGroupTab(newValue);
    },
    [setSelectedGroupTab]
  );

  const updatePermissions = useCallback((copyOfModuleSubModules) => {
    Object.entries(copyOfModuleSubModules).forEach(([key, value]) => {
      const submodulePermissions = Object.values(value?.permissions)?.slice(1);
      const permissionMap = new Map();
      submodulePermissions.forEach((item) => {
        permissionMap.set(item, permissionMap.get(item) + 1 || 1);
      });
      const keys = Array.from(permissionMap.keys());
      if (keys.includes('No') || keys.includes('Yes')) {
        const noCount = permissionMap.get('No') || 0;
        const yesCount = permissionMap.get('Yes') || 0;
        if (noCount === 0) {
          copyOfModuleSubModules[key].permissions[value?.key] = 'Manage';
        } else if (yesCount === 0) {
          copyOfModuleSubModules[key].permissions[value?.key] = 'None';
        } else {
          copyOfModuleSubModules[key].permissions[value?.key] = 'Custom';
        }
      } else {
        const noneCount = permissionMap.get('None') || 0;
        const manageCount = permissionMap.get('Manage') || 0;
        const viewCount = permissionMap.get('View') || 0;
        if (noneCount !== 0 && manageCount === 0 && viewCount === 0) {
          copyOfModuleSubModules[key].permissions[value?.key] = 'None';
        } else if (noneCount === 0 && manageCount !== 0 && viewCount === 0) {
          copyOfModuleSubModules[key].permissions[value?.key] = 'Manage';
        } else if (noneCount === 0 && manageCount === 0 && viewCount !== 0) {
          copyOfModuleSubModules[key].permissions[value?.key] = 'View';
        } else {
          copyOfModuleSubModules[key].permissions[value?.key] = 'Custom';
        }
      }
    });
  }, []);

  /**
   * Handles user selection updates, manages collaborators, and updates permissions accordingly.
   *
   * @param {Array} selectedUsers - Array of selected user objects.
   *
   * Steps:
   * 1. Updates the selected collaborators in the form.
   * 2. Calculates the total number of selected users.
   * 3. Identifies discarded users and updates module permissions.
   * 4. Fetches and applies permissions for newly added users.
   */
  const handleUserSelection = useCallback(
    (selectedUsers) => {
      setSelectedTab(0);
      const prevSelectedUser = formikForm?.values?.collaborators;
      formikForm.setFieldValue('collaborators', selectedUsers);
      const total = selectedUsers?.length; // Calculate the total selected users
      formikForm.setFieldValue('totalUsersSelected', total); // Update totalUsersSelected in formikForm

      // Identify discarded users
      const selectedUserIds = selectedUsers.map((u) => u?.id);
      const discardedUserIndex = prevSelectedUser.reduce((indices, u, idx) => {
        if (!selectedUserIds.includes(u?.id)) indices.push(idx);
        return indices;
      }, []);

      if (total) {
        if (discardedUserIndex?.length) {
          // Remove discarded indices and reindex remaining moduleSubModules
          const reindexedModuleSubmodule = Object.values(moduleSubModules)
            .filter((_, index) => !discardedUserIndex.includes(index))
            .reduce((acc, value, newIndex) => {
              acc[newIndex] = value;
              return acc;
            }, {});
          setModuleSubModules(reindexedModuleSubmodule);
        } else {
          // Handle newly added user
          const newUser = selectedUsers.find(
            (afterUser) =>
              !prevSelectedUser.some(
                (beforeUser) => beforeUser.id === afterUser.id
              )
          );
          // Fetching each collaborators permissions and updating modules submodules permissions
          // Merging the fetched permissions with the active user(owner's) permissions
          fetchCollaboratorsPermission({ user_id: newUser?.id }).then((res) => {
            const copyOfModuleSubModules = cloneDeep(modulesSubModuleList);
            Object.entries(res?.data?.user_permission)?.forEach(
              ([key, value]) => {
                Object.values(copyOfModuleSubModules).forEach((item) => {
                  if (key.split('_')[0] === item?.key) {
                    if (
                      item?.objKey === 'PO' ||
                      item?.objKey === 'UDF' ||
                      item?.objKey === 'AD' ||
                      item?.objKey === 'PIP' ||
                      item?.objKey === 'MM' ||
                      item?.objKey === 'TM'
                    ) {
                      if (
                        disabledPermissions.includes(key) ||
                        ownerModulesSubmodulesList[item?.objKey].permissions[
                          key
                        ] === 'No'
                      ) {
                        copyOfModuleSubModules[item?.objKey].permissions[key] =
                          'No';
                      } else {
                        copyOfModuleSubModules[item?.objKey].permissions[key] =
                          value || 'None';
                      }
                    } else if (
                      (ownerModulesSubmodulesList[item?.objKey].permissions[
                        key
                      ] === 'None' &&
                        (value === 'Manage' || value === 'View')) ||
                      disabledPermissions.includes(item)
                    ) {
                      copyOfModuleSubModules[item?.objKey].permissions[key] =
                        'None';
                    } else if (
                      ownerModulesSubmodulesList[item?.objKey].permissions[
                        key
                      ] === 'View' &&
                      (value === 'Manage' || value === 'View')
                    ) {
                      copyOfModuleSubModules[item?.objKey].permissions[key] =
                        'View';
                    } else {
                      copyOfModuleSubModules[item?.objKey].permissions[key] =
                        value;
                    }
                  }
                });
              }
            );
            // Calculating the count of Yes, No, Manage, View, None and updating the module permissions
            updatePermissions(copyOfModuleSubModules);
            setModuleSubModules((prevState) =>
              cloneDeep({
                ...prevState,
                [total - 1]: copyOfModuleSubModules,
              })
            );
          });
        }
      } else {
        setModuleSubModules({});
      }
    },
    [
      setSelectedTab,
      setModuleSubModules,
      fetchCollaboratorsPermission,
      moduleSubModules,
    ]
  );

  /**
   * Handles group selection updates, manages collaborators, and updates permissions accordingly.
   *
   * @param {Array} selectedGroups - Array of selected group objects.
   *
   * Steps:
   * 1. Updates the selected collaborators in the form.
   * 2. Calculates the total number of selected groups.
   * 3. Identifies discarded groups and updates module permissions.
   * 4. Fetches and applies permissions for newly added groups.
   */
  const handleGroupSelection = (selectedGroups) => {
    setSelectedGroupTab(0);
    const prevSelectedGroup = formikForm.values.groups;
    formikForm.setFieldValue('groups', selectedGroups);
    const total = selectedGroups?.length; // Calculate the total selected users
    formikForm.setFieldValue('totalGroupsSelected', total); // Update totalUsersSelected in formikForm

    // Identify discarded users
    const selectedGroupIds = selectedGroups.map((u) => u?.id);
    const discardedGroupIndex = prevSelectedGroup.reduce((indices, u, idx) => {
      if (!selectedGroupIds.includes(u?.id)) indices.push(idx);
      return indices;
    }, []);

    if (total) {
      if (discardedGroupIndex?.length) {
        // Remove discarded indices and reindex remaining moduleSubModules
        const reindexedModuleSubmodule = Object.values(
          moduleSubModulesForGroups
        )
          .filter((_, index) => !discardedGroupIndex.includes(index))
          .reduce((acc, value, newIndex) => {
            acc[newIndex] = value;
            return acc;
          }, {});
        discardedGroupIndex.forEach((index) => {
          delete moduleSubModulesForGroups[index];
        });
        setModuleSubModulesForGroups(reindexedModuleSubmodule);
      } else {
        // Handle newly added user
        const newGroup = selectedGroups.find(
          (afterGroup) =>
            !prevSelectedGroup.some(
              (beforeGroup) => beforeGroup?.id === afterGroup?.id
            )
        );
        // Fetching each collaborators permissions and updating modules submodules permissions
        // Merging the fetched permissions with the active user(owner's) permissions
        fetchCollaboratorsPermission({ group_name: newGroup?.name }).then(
          (res) => {
            const copyOfModuleSubModules = cloneDeep(modulesSubModuleList);
            Object.entries(res?.data?.user_permission)?.forEach(
              ([key, value]) => {
                Object.values(copyOfModuleSubModules).forEach((item) => {
                  if (key.split('_')[0] === item?.key) {
                    if (
                      item?.objKey === 'PO' ||
                      item?.objKey === 'UDF' ||
                      item?.objKey === 'AD' ||
                      item?.objKey === 'PIP' ||
                      item?.objKey === 'MM' ||
                      item?.objKey === 'TM'
                    ) {
                      if (
                        disabledPermissions.includes(key) ||
                        ownerModulesSubmodulesList[item?.objKey].permissions[
                          key
                        ] === 'No'
                      ) {
                        copyOfModuleSubModules[item?.objKey].permissions[key] =
                          'No';
                      } else {
                        copyOfModuleSubModules[item?.objKey].permissions[key] =
                          value || 'None';
                      }
                    } else if (
                      (ownerModulesSubmodulesList[item?.objKey].permissions[
                        key
                      ] === 'None' &&
                        (value === 'Manage' || value === 'View')) ||
                      disabledPermissions.includes(item)
                    ) {
                      copyOfModuleSubModules[item?.objKey].permissions[key] =
                        'None';
                    } else if (
                      ownerModulesSubmodulesList[item?.objKey].permissions[
                        key
                      ] === 'View' &&
                      (value === 'Manage' || value === 'View')
                    ) {
                      copyOfModuleSubModules[item?.objKey].permissions[key] =
                        'View';
                    } else {
                      copyOfModuleSubModules[item?.objKey].permissions[key] =
                        value;
                    }
                  }
                });
              }
            );
            // Calculating the count of Yes, No, Manage, View, None and updating the module permissions
            updatePermissions(copyOfModuleSubModules);
            setModuleSubModulesForGroups((prevState) => ({
              ...prevState,
              [total - 1]: cloneDeep(copyOfModuleSubModules),
            }));
          }
        );
      }
    } else {
      setModuleSubModulesForGroups({});
    }
  };

  const handleOnClose = useCallback(() => {
    setIsCollaborative('False');
    setModuleSubModules({});
    setModuleSubModulesForGroups({});
    setUserAllPermissions({});
    formikForm.resetForm();
    handleClose();
  }, [
    setIsCollaborative,
    setModuleSubModules,
    setModuleSubModulesForGroups,
    setUserAllPermissions,
    formikForm,
    handleClose,
  ]);

  const handleClick = useCallback(() => {
    setIsCollaborative('False');
    setModuleSubModules({});
    setModuleSubModulesForGroups({});
    setUserAllPermissions({});
    formikForm.resetForm();
    handleClose();
  }, [
    setIsCollaborative,
    setModuleSubModules,
    setModuleSubModulesForGroups,
    setUserAllPermissions,
    formikForm,
    handleClose,
  ]);

  const getOptionLabel = useCallback((option) => {
    return option?.username ? option.username : '';
  }, []);

  const isOptionEqualToValue = useCallback((option, val) => {
    return option?.id === val?.id;
  }, []);

  const getOptionLabeForGroups = useCallback((option) => {
    return option?.name ? option.name : '';
  }, []);

  const handleChange = useCallback(
    (e) => {
      handleUserSelection(e);
    },
    [handleUserSelection]
  );

  const handleChangeForGroups = useCallback(
    (e) => {
      handleGroupSelection(e);
    },
    [handleGroupSelection]
  );

  const renderTags = useCallback((tagValue, getTagProps) => {
    return tagValue.map((option, index) => (
      <Chip
        key={option.id}
        color="primary"
        label={option?.username}
        {...getTagProps({ index })}
        size="small"
      />
    ));
  }, []);

  const renderTagsForGroups = useCallback((tagValue, getTagProps) => {
    return tagValue.map((option, index) => (
      <Chip
        key={option.id}
        color="primary"
        label={option?.name}
        {...getTagProps({ index })}
        size="small"
      />
    ));
  }, []);

  const getSx = useCallback(() => {
    return {
      border: 'none',
      '& .MuiTabs-indicator': {
        display: 'none',
      },
    };
  }, []);

  const handleSubmit = useCallback(() => {
    formikForm.handleSubmit();
  }, [formikForm]);

  useEffect(() => {
    document.addEventListener('CLOSE_MODALS', handleOnClose);
    return () => {
      document.removeEventListener('CLOSE_MODALS', handleOnClose);
    };
  }, [handleOnClose]);
  useEffect(() => {
    if (tabIndex === 1 && (!hasGroups || !hasCollaborators)) {
      setTabIndex(null, 0);
    }
  }, [hasCollaborators, hasGroups]);
  const fetchUsersWrapper = (pattern) => {
    return fetchUserRecipients(1, 20, pattern || '').then((resp) => {
      return resp?.data || [];
    });
  };
  const fetchGroupsWrapper = (pattern) => {
    return fetchGroups(1, 20, pattern || '').then((resp) => {
      return resp?.data || [];
    });
  };

  const getFilteredOptionsForUsers = useCallback(
    (options) => {
      const filteredList = options?.filter(
        (ele) => ele?.id !== user?.userData?.id && ele?.id !== null
      );
      const mergedArray = [
        ...filteredList,
        ...formikForm.values?.collaborators,
      ].reduce((acc, current) => {
        // Check if the id is already in the accumulator
        if (
          !acc.some((item) => item.id === current.id && current.id !== null)
        ) {
          acc.push(current);
        }
        return acc;
      }, []);
      return mergedArray;
    },
    [formikForm.values?.collaborators, user?.userData?.id]
  );
  const getFilteredOptionsForGroups = useCallback(
    (options) => {
      const mergedArray = [...options, ...formikForm.values?.groups].reduce(
        (acc, current) => {
          // Check if the id is already in the accumulator
          if (
            !acc.some((item) => item.id === current.id && current.id !== null)
          ) {
            acc.push(current);
          }
          return acc;
        },
        []
      );
      return mergedArray;
    },
    [formikForm.values?.groups]
  );

  return (
    <Dialog
      onClose={handleOnClose}
      aria-labelledby="customized-dialog-title"
      maxWidth={displayCollaboratorsOrGroups ? 'xl' : 'xs'}
      fullWidth={true}
      TransitionComponent={DialogTransition}
      open={open}
    >
      <DialogTitle>
        <Box component="span" aria-live="polite" aria-atomic="true">
          {mode === 'EDIT' ? 'Edit' : 'Create'} Project
        </Box>
      </DialogTitle>

      <IconButton
        color="primary"
        aria-label="Close dialog"
        onClick={handleClick}
        sx={{
          position: 'absolute',
          right: 16,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Grid item pb={2} xs={12}>
          <Typography
            variant="body4"
            tabIndex={0}
            role="note"
            aria-label="Important note: Fields marked with an asterisk are mandatory."
            sx={{
              fontStyle: 'normal',
              border: 'none',
              '&:focus': {
                border: '2px solid',
                borderColor: 'primary.main',
              },
            }}
          >
            <strong>Note:</strong>&nbsp;
            <i>Fields marked with * are mandatory.</i>
          </Typography>
        </Grid>
        <Grid container m={2} mr={-3}>
          <Grid
            container
            item
            xs={displayCollaboratorsOrGroups ? 3 : 11}
            spacing={2}
          >
            <Box
              display="flex"
              flexDirection="column"
              gap={2}
              width="100%"
              pr={displayCollaboratorsOrGroups ? 2 : -2}
            >
              <TextField
                required
                label="Project name"
                name="name"
                placeholder="Enter project name"
                {...formikForm.getFieldProps('name')}
                error={
                  formikForm?.touched?.name && Boolean(formikForm?.errors?.name)
                }
                helperText={
                  formikForm?.touched?.name && formikForm?.errors?.name
                    ? formikForm.errors.name
                    : null
                }
                fullWidth={false}
                aria-required="true"
                aria-invalid={
                  formikForm.touched.name && Boolean(formikForm.errors.name)
                    ? 'true'
                    : 'false'
                }
                aria-describedby={
                  formikForm?.touched?.name && formikForm?.errors?.name
                    ? 'name-helper-text'
                    : undefined
                }
                FormHelperTextProps={{
                  id: 'name-helper-text',
                }}
              />
              <TextField
                required
                label="Description"
                name="description"
                placeholder="Enter description"
                multiline
                rows={3}
                {...formikForm.getFieldProps('description')}
                error={
                  formikForm?.touched?.description &&
                  Boolean(formikForm?.errors?.description)
                }
                helperText={
                  formikForm?.touched?.description &&
                  formikForm?.errors?.description
                    ? formikForm.errors.description
                    : null
                }
                aria-required="true"
                aria-invalid={
                  formikForm?.touched?.description &&
                  Boolean(formikForm.errors.description)
                    ? 'true'
                    : 'false'
                }
                aria-describedby={
                  formikForm?.touched?.description &&
                  formikForm?.errors?.description
                    ? 'description-helper-text'
                    : undefined
                }
                FormHelperTextProps={{
                  id: 'description-helper-text',
                }}
              />
              <DropDown
                required
                role="region"
                label="Project type"
                placeholder="Select project type"
                name="type"
                {...formikForm.getFieldProps('type')}
                error={
                  formikForm?.touched?.type && Boolean(formikForm.errors.type)
                }
                helperText={
                  formikForm?.touched?.type && formikForm?.errors?.type
                    ? formikForm?.errors?.type
                    : null
                }
                aria-required="true"
                aria-invalid={
                  formikForm?.touched?.type && Boolean(formikForm.errors.type)
                    ? 'true'
                    : 'false'
                }
                aria-describedby={
                  formikForm?.touched?.type && formikForm?.errors?.type
                    ? 'type-helper-text'
                    : undefined
                }
                FormHelperTextProps={{
                  id: 'type-helper-text',
                }}
              >
                {projectTypes.map((item, _index) => (
                  <DropdownItem value={item} key={item}>
                    {utils.toTitleCase(item)}
                  </DropdownItem>
                ))}
              </DropDown>
              <DropDown
                label="Model type"
                name="regulation"
                placeholder="Select model type"
                disabled={mode === 'EDIT'}
                {...formikForm.getFieldProps('regulation')}
                helperText={
                  formikForm?.errors?.regulation &&
                  formikForm?.touched?.regulation
                    ? formikForm.errors.regulation
                    : null
                }
              >
                {/* <DropdownItemGroup>Non time series</DropdownItemGroup> */}
                {REGULATIONS.filter((item) => !item.isTs).map((item) => (
                  <DropdownItem value={item.key} key={item.key}>
                    {item?.label}
                  </DropdownItem>
                ))}
                {/* <DropdownItemGroup>Time series</DropdownItemGroup> */}
                {REGULATIONS.filter((item) => item.isTs).map((item) => (
                  <DropdownItem value={item.key} key={item.key}>
                    {item?.label}
                  </DropdownItem>
                ))}
              </DropDown>

              {/* Live region for announcing error messages for screen readers WCAG */}
              <div
                aria-live="polite"
                style={{
                  width: '0px',
                  height: '0px',
                  overflow: 'hidden',
                }}
              >
                {formikForm?.errors?.name && formikForm?.touched?.name && (
                  <span id="name-helper-text-live">
                    {`Error in Project Name field: ${formikForm?.errors?.name}`}
                  </span>
                )}
                {formikForm?.errors?.description &&
                  formikForm?.touched?.description && (
                    <span id="description-helper-text-live">
                      {`Error in Description field: ${formikForm?.errors?.description}`}
                    </span>
                  )}
                {formikForm?.errors?.type && formikForm?.touched?.type && (
                  <span id="type-helper-text-live">
                    {`Error in Project Type field: ${formikForm?.errors?.type}`}
                  </span>
                )}
              </div>

              {mode === 'CREATE' && (
                <>
                  <Typography
                    tabIndex={0}
                    role="note"
                    aria-label="Is this a collaborative project?"
                    sx={(theme) => ({
                      '&:focus-visible': {
                        outline: 'none',
                        border: `2px solid ${theme?.palette?.primary?.main} !important`,
                      },
                    })}
                  >
                    Is this a collaborative project?
                  </Typography>

                  <FormControl variant="standard">
                    <RadioGroup
                      value={isCollaborative}
                      onChange={handleRadioChange}
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        marginLeft: 1,
                      }}
                    >
                      <FormControlLabel
                        value="True"
                        control={<Radio />}
                        label="Yes"
                        disabled={
                          createCollaborativeProjectPermission !== 'Yes'
                        }
                        title={
                          createCollaborativeProjectPermission !== 'Yes'
                            ? UNAUTHORIZED_MESSAGE
                            : ''
                        }
                      />
                      <FormControlLabel
                        value="False"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                </>
              )}
              {isCollaborative === 'True' && (
                <>
                  <Typography
                    variant="body4"
                    tabIndex={0}
                    role="note"
                    aria-label="At least one user or one group is required."
                    sx={{
                      fontStyle: 'normal',
                      border: 'none',
                      '&:focus': {
                        border: '2px solid',
                        borderColor: 'primary.main',
                      },
                    }}
                  >
                    <strong>Note:</strong>&nbsp;
                    <i>At least one user or one group is required.</i>
                  </Typography>
                  <ControlledMultiSelect
                    fetchData={fetchUsersWrapper}
                    disableCloseOnSelect={false}
                    value={
                      formikForm?.values?.collaborators
                        ? formikForm.values.collaborators
                        : []
                    }
                    disabled={
                      mode === 'EDIT' &&
                      project?.is_collaborative &&
                      project?.user_id !== user?.userData?.id
                    }
                    limitTags={3}
                    label="Users"
                    placeholder="Select users"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    name="users"
                    options={[]}
                    disableClearable={['', undefined].includes(
                      formikForm?.values?.collaborators
                    )}
                    noOptionsText="No users are available."
                    onChange={handleChange}
                    onBlur={formikForm.handleBlur('collaborators')}
                    getOptionLabel={getOptionLabel}
                    isOptionEqualToValue={isOptionEqualToValue}
                    renderTags={renderTags}
                    error={
                      formikForm?.touched?.collaborators &&
                      Boolean(formikForm?.errors?.collaborators)
                    }
                    helperText={
                      formikForm?.errors?.collaborators &&
                      formikForm?.touched?.collaborators
                        ? formikForm.errors.collaborators
                        : null
                    }
                    getFilteredOptions={getFilteredOptionsForUsers}
                  />
                  <ControlledMultiSelect
                    fetchData={fetchGroupsWrapper}
                    disableCloseOnSelect={false}
                    value={
                      formikForm?.values?.groups ? formikForm.values.groups : []
                    }
                    disabled={
                      mode === 'EDIT' &&
                      project?.is_collaborative &&
                      project?.user_id !== user?.userData?.id
                    }
                    limitTags={3}
                    label="Groups"
                    placeholder="Select groups"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    name="groups"
                    options={[]}
                    disableClearable={['', undefined].includes(
                      formikForm?.values?.groups
                    )}
                    noOptionsText="No groups are available."
                    onChange={handleChangeForGroups}
                    onBlur={formikForm.handleBlur('groups')}
                    getOptionLabel={getOptionLabeForGroups}
                    isOptionEqualToValue={isOptionEqualToValue}
                    renderTags={renderTagsForGroups}
                    error={
                      formikForm?.touched?.groups &&
                      Boolean(formikForm?.errors?.groups)
                    }
                    helperText={
                      formikForm?.errors?.groups && formikForm?.touched?.groups
                        ? formikForm.errors.groups
                        : null
                    }
                    getFilteredOptions={getFilteredOptionsForGroups}
                  />
                </>
              )}
            </Box>
          </Grid>
          {displayCollaboratorsOrGroups && (
            <Grid container item xs={9} height={0}>
              <Tabs
                value={tabIndex}
                onChange={setTabIndex}
                height={0}
                variant="scrollable"
                scrollButtons="auto"
                sx={{ pl: 1.5, borderBottom: '0px', width: '100%' }}
              >
                {hasCollaborators && <Tab label="Users" id="users" />}
                {hasGroups && <Tab label="Groups" id="groups" />}
                <Box
                  mt={1}
                  ml={2}
                  mr={2}
                  display="flex"
                  width="100%"
                  textAlign="right"
                  flexDirection="row"
                  alignItems="center"
                >
                  <Typography
                    variant="body4"
                    tabIndex={0}
                    role="note"
                    aria-label="Important note: Fields marked with an asterisk are mandatory."
                    sx={{
                      fontStyle: 'normal',
                      width: '100%',
                      border: 'none',
                      '&:focus': {
                        border: '2px solid',
                        borderColor: 'primary.main',
                      },
                    }}
                  >
                    <strong>Note:</strong>&nbsp;
                    <i>
                      Sharing, cloning and delete permissions are restricted to
                      collaborators by default. You can allow them as needed.
                    </i>
                  </Typography>
                </Box>
              </Tabs>
              {tabIndex === 0 && (
                <>
                  {hasCollaborators ? (
                    <Box display="flex" width="100%" tabIndex={0}>
                      <Grid
                        display="flex"
                        sx={{
                          borderLeft: (theme) =>
                            `1px solid ${theme.palette.other.gray3}`,
                        }}
                        p={1}
                      >
                        <Box
                          borderRadius={2}
                          backgroundColor="white"
                          sx={{
                            border: (theme) =>
                              `1px solid ${theme.palette.other.gray3}`,
                          }}
                        >
                          <Box
                            p={1}
                            display="flex"
                            justifyContent="center"
                            backgroundColor="white"
                            sx={{
                              borderBottom: (theme) =>
                                `1px solid ${theme.palette.other.gray3}`,
                            }}
                            aria-label="users"
                          >
                            <Typography variant="body1">Users</Typography>
                          </Box>
                          <Tabs
                            value={selectedTab}
                            onChange={handleTabChange}
                            variant="scrollable"
                            orientation="vertical"
                            sx={getSx}
                          >
                            {formikForm?.values?.collaborators?.map((item) => (
                              <UserTab
                                key={item?.id}
                                title={item?.username}
                                label={
                                  <EllipsisBox>
                                    <Typography
                                      variant="body1"
                                      component="span"
                                    >
                                      {item?.username}
                                    </Typography>
                                  </EllipsisBox>
                                }
                                aria-controls={`tabpanel-${tabIndex}`}
                                aria-selected={
                                  selectedTab === tabIndex ? 'true' : 'false'
                                }
                                id={`tab-${tabIndex}`}
                                sx={{ textTransform: 'capitalize' }}
                              />
                            ))}
                          </Tabs>
                        </Box>
                      </Grid>
                      <Box p={1} width="1200px">
                        <Grid item xs={12}>
                          <Box
                            sx={{
                              borderLeft: (theme) =>
                                `1px solid ${theme.palette.other.gray3}`,
                            }}
                          >
                            {moduleSubModules &&
                              Object.keys(moduleSubModules)?.length > 0 &&
                              Object.keys(ownerModulesSubmodulesList)?.length >
                                0 && (
                                <UserPermission
                                  mode={mode}
                                  project={project}
                                  activeUser={user?.userData}
                                  selectedTab={selectedTab}
                                  moduleSubModules={moduleSubModules}
                                  setModuleSubModules={setModuleSubModules}
                                  ownerModulesSubmodulesList={
                                    ownerModulesSubmodulesList
                                  }
                                />
                              )}
                          </Box>
                        </Grid>
                      </Box>
                    </Box>
                  ) : (
                    <>
                      {hasGroups ? (
                        <Box display="flex" width="100%" tabIndex={0}>
                          <Grid
                            display="flex"
                            sx={{
                              borderLeft: (theme) =>
                                `1px solid ${theme.palette.other.gray3}`,
                            }}
                            p={1}
                          >
                            <Box
                              borderRadius={2}
                              backgroundColor="white"
                              sx={{
                                border: (theme) =>
                                  `1px solid ${theme.palette.other.gray3}`,
                              }}
                            >
                              <Box
                                p={1}
                                display="flex"
                                justifyContent="center"
                                backgroundColor="white"
                                sx={{
                                  borderBottom: (theme) =>
                                    `1px solid ${theme.palette.other.gray3}`,
                                }}
                                aria-label="Groups tab"
                              >
                                <Typography variant="body1">Groups</Typography>
                              </Box>
                              <Tabs
                                value={selectedGroupTab}
                                onChange={handleTabChangeForGroups}
                                variant="scrollable"
                                orientation="vertical"
                                sx={getSx}
                              >
                                {formikForm?.values?.groups?.map((item) => (
                                  <UserTab
                                    key={item?.id}
                                    title={item?.name}
                                    label={
                                      <EllipsisBox>
                                        <Typography
                                          variant="body1"
                                          component="span"
                                        >
                                          {item?.name}
                                        </Typography>
                                      </EllipsisBox>
                                    }
                                    aria-controls={`tabpanel-${tabIndex}`}
                                    aria-selected={
                                      selectedTab === tabIndex
                                        ? 'true'
                                        : 'false'
                                    }
                                    id={`tab-${tabIndex}`}
                                    sx={{ textTransform: 'capitalize' }}
                                  />
                                ))}
                              </Tabs>
                            </Box>
                          </Grid>
                          <Box p={1} width="1200px">
                            <Grid item xs={12}>
                              <Box
                                sx={{
                                  borderLeft: (theme) =>
                                    `1px solid ${theme.palette.other.gray3}`,
                                }}
                              >
                                {moduleSubModulesForGroups &&
                                  Object.keys(moduleSubModulesForGroups)
                                    ?.length > 0 &&
                                  Object.keys(ownerModulesSubmodulesList)
                                    ?.length > 0 && (
                                    <UserPermission
                                      mode={mode}
                                      project={project}
                                      activeUser={user?.userData}
                                      selectedTab={selectedGroupTab}
                                      moduleSubModules={
                                        moduleSubModulesForGroups
                                      }
                                      setModuleSubModules={
                                        setModuleSubModulesForGroups
                                      }
                                      ownerModulesSubmodulesList={
                                        ownerModulesSubmodulesList
                                      }
                                    />
                                  )}
                              </Box>
                            </Grid>
                          </Box>
                        </Box>
                      ) : (
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          sx={{
                            borderLeft: (theme) =>
                              `1px solid ${theme.palette.other.gray3}`,
                          }}
                          width="100%"
                          height="80%"
                          pt="20%"
                        >
                          <Typography>No collaborators selected.</Typography>
                        </Box>
                      )}
                    </>
                  )}
                </>
              )}
              {tabIndex === 1 && (
                <>
                  {hasGroups ? (
                    <Box display="flex" width="100%" tabIndex={0}>
                      <Grid
                        display="flex"
                        sx={{
                          borderLeft: (theme) =>
                            `1px solid ${theme.palette.other.gray3}`,
                        }}
                        p={1}
                      >
                        <Box
                          borderRadius={2}
                          backgroundColor="white"
                          sx={{
                            border: (theme) =>
                              `1px solid ${theme.palette.other.gray3}`,
                          }}
                        >
                          <Box
                            p={1}
                            display="flex"
                            justifyContent="center"
                            backgroundColor="white"
                            sx={{
                              borderBottom: (theme) =>
                                `1px solid ${theme.palette.other.gray3}`,
                            }}
                            aria-label="Groups tab"
                          >
                            <Typography variant="body1">Groups</Typography>
                          </Box>
                          <Tabs
                            value={selectedGroupTab}
                            onChange={handleTabChangeForGroups}
                            variant="scrollable"
                            orientation="vertical"
                            sx={getSx}
                          >
                            {formikForm?.values?.groups?.map((item) => (
                              <UserTab
                                key={item?.id}
                                title={item?.name}
                                label={
                                  <EllipsisBox>
                                    <Typography
                                      variant="body1"
                                      component="span"
                                    >
                                      {item?.name}
                                    </Typography>
                                  </EllipsisBox>
                                }
                                aria-controls={`tabpanel-${tabIndex}`}
                                aria-selected={
                                  selectedTab === tabIndex ? 'true' : 'false'
                                }
                                id={`tab-${tabIndex}`}
                                sx={{ textTransform: 'capitalize' }}
                              />
                            ))}
                          </Tabs>
                        </Box>
                      </Grid>
                      <Box p={1} width="1200px">
                        <Grid item xs={12}>
                          <Box
                            sx={{
                              borderLeft: (theme) =>
                                `1px solid ${theme.palette.other.gray3}`,
                            }}
                          >
                            {moduleSubModulesForGroups &&
                              Object.keys(moduleSubModulesForGroups)?.length >
                                0 &&
                              Object.keys(ownerModulesSubmodulesList)?.length >
                                0 && (
                                <UserPermission
                                  mode={mode}
                                  project={project}
                                  userData={user?.userData}
                                  selectedTab={selectedGroupTab}
                                  moduleSubModules={moduleSubModulesForGroups}
                                  setModuleSubModules={
                                    setModuleSubModulesForGroups
                                  }
                                  ownerModulesSubmodulesList={
                                    ownerModulesSubmodulesList
                                  }
                                />
                              )}
                          </Box>
                        </Grid>
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      sx={{
                        borderLeft: (theme) =>
                          `1px solid ${theme.palette.other.gray3}`,
                      }}
                      width="100%"
                      height="80%"
                      pt="20%"
                    >
                      <Typography>No Groups selected.</Typography>
                    </Box>
                  )}
                </>
              )}
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          title={
            mode !== 'CREATE'
              ? permissions?.editProject !== 'Yes' ||
                (mode === 'EDIT' &&
                  project?.is_collaborative &&
                  project?.user_id !== user?.userData?.id)
                ? UNAUTHORIZED_MESSAGE
                : ''
              : ''
          }
          aria-label={
            mode !== 'CREATE'
              ? permissions?.editProject !== 'Yes' ||
                (mode === 'EDIT' &&
                  project?.is_collaborative &&
                  project?.user_id !== user?.userData?.id)
                ? UNAUTHORIZED_MESSAGE
                : ''
              : ''
          }
          disabled={
            mode !== 'CREATE'
              ? permissions?.editProject !== 'Yes' ||
                (mode === 'EDIT' &&
                  project?.is_collaborative &&
                  project?.user_id !== user?.userData?.id)
              : false
          }
          onClick={() => {
            if (mode === 'EDIT') {
              formikForm.setValues({
                name: '',
                description: '',
                type: '',
                regulation: project.regulation,
              });
              setModuleSubModules({});
              setModuleSubModulesForGroups({});
              setUserAllPermissions({});
              setIsCollaborative('False');
              formikForm.setTouched({}, false);
            } else {
              setModuleSubModules({});
              setModuleSubModulesForGroups({});
              setUserAllPermissions({});
              setIsCollaborative('False');
              formikForm.resetForm();
            }
          }}
          variant="outlined"
        >
          reset
        </Button>
        <Button
          title={
            mode !== 'CREATE'
              ? permissions?.editProject !== 'Yes' ||
                (mode === 'EDIT' &&
                  project?.is_collaborative &&
                  project?.user_id !== user?.userData?.id)
                ? UNAUTHORIZED_MESSAGE
                : ''
              : ''
          }
          aria-label={
            mode !== 'CREATE'
              ? permissions?.editProject !== 'Yes' ||
                (mode === 'EDIT' &&
                  project?.is_collaborative &&
                  project?.user_id !== user?.userData?.id)
                ? UNAUTHORIZED_MESSAGE
                : ''
              : ''
          }
          disabled={
            (mode !== 'CREATE' ? permissions?.editProject !== 'Yes' : false) ||
            project?.share_status === 'Failed' ||
            project?.clone_status === 'Failed' ||
            (mode === 'EDIT' &&
              project?.is_collaborative &&
              project?.user_id !== user?.userData?.id)
          }
          color="primary"
          variant="contained"
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}

CreateEditProjectModal.defaultProps = {
  project: null,
  updateProject: () => {},
  activateProject: () => {},
  permissions: {},
  fetchUserProjectsStatus: () => {},
  fromAppHeader: false,
  taskUpdate: () => {},
  taskId: null,
  fetchTasksWithPagination: () => {},
  fromTaskManager: false,
  selectedTaskModelId: null,
};

CreateEditProjectModal.propTypes = {
  createNewProject: PropTypes.func.isRequired,
  fetchProjects: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  project: PropTypes.oneOfType([PropTypes.object]),
  updateProject: PropTypes.func,
  activateProject: PropTypes.func,
  permissions: PropTypes.oneOfType([PropTypes.object]),
  fetchUserProjectsStatus: PropTypes.func,
  fetchProjectTypes: PropTypes.func.isRequired,
  pageIndex: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  searchTerm: PropTypes.string.isRequired,
  projectType: PropTypes.oneOfType([PropTypes.object]).isRequired,
  modelType: PropTypes.oneOfType([PropTypes.object]).isRequired,
  sortField: PropTypes.string.isRequired,
  sortOrder: PropTypes.string.isRequired,
  setProjectList: PropTypes.func.isRequired,
  fromAppHeader: PropTypes.bool,
  editProjectClicked: PropTypes.bool.isRequired,
  setEditProjectClicked: PropTypes.func.isRequired,
  createCollaborativeProjectPermission: PropTypes.string.isRequired,
  taskUpdate: PropTypes.func,
  taskId: PropTypes.number,
  fetchTasksWithPagination: PropTypes.func,
  fromTaskManager: PropTypes.bool,
  selectedTaskModelId: PropTypes.number,
};

export default CreateEditProjectModal;
